export const API = 'https://oper.kaktus.media/admin/dashboard.api.php';
// export const API = 'https://oper.kaktus.media/admin/dashboard.api.php';
// export const API = 'http://localhost/media.kaktus/admin/dashboard.api.php';